import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDiamond } from "types/diamond";

export const initialState: IDiamond = {
  appBalance: 0,
  lockedAmount: 0,
  totalLockedAmount: 0,
  totalEarnedAmount: 0,
  totalUnlockedAmount: 0,
  history: [
    {
      poolId: 0,
      appLockedAmount: 0,
      plan: "",
      startDate: "",
      dueDate: "",
      appEarnedAmount: 0,
      claimed: false,
    },
  ],
};

export const diamondSlice = createSlice({
  name: "diamond",
  initialState,
  reducers: {
    logg(state, action: PayloadAction<any>) {
      console.log(action.payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const { actions: diamondActions } = diamondSlice;

export default diamondSlice.reducer;
